import React from 'react';
import CustomButton from '../../../../../../../common/Button/CustomButton/CustomButton';
import { theme } from '../../../../../../../../core/theme/theme';
import { useDispatch } from 'react-redux';
import { setIsMeasuringToolDeleteClicked } from '../../../../../../../../app/redux/slices/isMeasuringToolDeleteClickedSlice';

const MeasureToolMenu = () => {
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(setIsMeasuringToolDeleteClicked(true));
    };
    return (
        <>
            <div style={{ right: '45px', position: 'absolute' }}>
                <CustomButton
                    onClick={handleClick}
                    padding={8}
                    color={theme.colors.selected_color}
                    textColor={theme.colors.default}
                    fontSize="9px"
                    text="حذف"
                />
            </div>
        </>
    );
};

export default MeasureToolMenu;
